import React from "react";
import { Handle, Position } from "@xyflow/react";
import { FaGlobe } from "react-icons/fa";

export default function TriggerWebhookNode({ data, selected }) {
  return (
    <div
      className={`rounded-xl border-2 bg-surface-card shadow-sm min-w-[200px] transition-shadow ${
        selected ? "border-red-500 shadow-md" : "border-surface-border"
      }`}
    >
      {/* Input handle */}
      <Handle
        type="target"
        position={Position.Top}
        className="!w-3 !h-3 !bg-red-500 !border-2 !border-white"
      />

      {/* Header */}
      <div className="flex items-center gap-2 px-3 py-2 rounded-t-[10px] bg-red-500">
        <FaGlobe size={10} className="text-white" />
        <span className="text-xs font-semibold text-white">Trigger Webhook</span>
      </div>

      {/* Body */}
      <div className="px-3 py-2.5">
        {data.webhookUrl ? (
          <p className="text-xs text-ink-primary truncate max-w-[180px]" title={data.webhookUrl}>
            {data.webhookUrl}
          </p>
        ) : (
          <p className="text-xs text-ink-muted italic">Click to configure URL</p>
        )}
      </div>

      {/* Output handle */}
      <Handle
        type="source"
        position={Position.Bottom}
        className="!w-3 !h-3 !bg-red-500 !border-2 !border-white"
      />
    </div>
  );
}
